<script lang="ts">
	import Info from 'lucide-svelte/icons/info'
	import TriangleAlert from 'lucide-svelte/icons/triangle-alert'

	import * as Popover from '$lib/components/ui/popover'
	import { cn } from '$lib/utils/shadcn'

	export let content: string | null = null
	export let ariaLabel: string | null = null
	export let type: 'info' | 'warning' = 'info'
</script>

{#if content}
	<Popover.Root>
		<Popover.Trigger
			class={cn(
				'focus-visible:ring-ring flex size-4 items-center justify-center rounded-full p-0.5 focus-visible:ring-3',
				type === 'info'
					? 'text-muted-foreground hover:text-foreground'
					: 'text-orange-400 hover:text-orange-500'
			)}
			aria-label={ariaLabel}
		>
			{#if type === 'info'}
				<Info />
			{:else}
				<TriangleAlert />
			{/if}
		</Popover.Trigger>

		<Popover.Content class="links-inside w-auto max-w-[300px] p-2 text-sm" side="top">
			<!-- eslint-disable-next-line svelte/no-at-html-tags -->
			{@html content}
		</Popover.Content>
	</Popover.Root>
{/if}
